// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_draftProperty_price(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DraftPropertyExactPrice",
    "DraftPropertyPriceRange"
  ]);
}

function unwrap_fragment_draftProperty_propertyData(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DraftPropertyDataForSaleV5",
    "DraftPropertyDataRentalV5"
  ]);
}

let fragmentConverter = {"__root":{"draftProperty_showings_date":{"b":""},"draftProperty_propertyData_DraftPropertyDataRentalV5_availableFrom":{"b":""},"draftProperty_propertyData":{"u":"fragment_draftProperty_propertyData"},"draftProperty_price":{"u":"fragment_draftProperty_price"},"draftProperty_onMlsAt":{"b":""},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_draftProperty_price: unwrap_fragment_draftProperty_price,
  fragment_draftProperty_propertyData: unwrap_fragment_draftProperty_propertyData
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function draftV5Status_decode($$enum) {
  if ($$enum === "DELETED" || $$enum === "RESUMABLE_DRAFT" || $$enum === "DRAFT" || $$enum === "PUBLISHED" || $$enum === "EXPIRED") {
    return $$enum;
  }
}

let draftV5Status_fromString = draftV5Status_decode;

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function leaseLengthValue_decode($$enum) {
  if ($$enum === "LONG" || $$enum === "SHORT_OR_LONG" || $$enum === "SHORT") {
    return $$enum;
  }
}

let leaseLengthValue_fromString = leaseLengthValue_decode;

function lotSizeUnit_decode($$enum) {
  if ($$enum === "ACRE" || $$enum === "SQ_FT") {
    return $$enum;
  }
}

let lotSizeUnit_fromString = lotSizeUnit_decode;

function mlsListingTypeV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "OFF_MLS" || $$enum === "COMING_SOON") {
    return $$enum;
  }
}

let mlsListingTypeV5_fromString = mlsListingTypeV5_decode;

function onOrOffV5_decode($$enum) {
  if ($$enum === "OFF" || $$enum === "ON") {
    return $$enum;
  }
}

let onOrOffV5_fromString = onOrOffV5_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

function showingTypeV5_decode($$enum) {
  if ($$enum === "AGENTS_ONLY" || $$enum === "TAN_ONLY" || $$enum === "BUYERS_WELCOME") {
    return $$enum;
  }
}

let showingTypeV5_fromString = showingTypeV5_decode;

let Utils = {
  draftV5Status_decode: draftV5Status_decode,
  draftV5Status_fromString: draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: leaseLengthValue_fromString,
  lotSizeUnit_decode: lotSizeUnit_decode,
  lotSizeUnit_fromString: lotSizeUnit_fromString,
  mlsListingTypeV5_decode: mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: mlsListingTypeV5_fromString,
  onOrOffV5_decode: onOrOffV5_decode,
  onOrOffV5_fromString: onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: showingTypeV5_decode,
  showingTypeV5_fromString: showingTypeV5_fromString
};

let node = {
  "kind": "InlineDataFragment",
  "name": "PropertyWizardFormRelay_inlineServerDraft"
};

let wrap_fragment_draftProperty_price = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_draftProperty_propertyData = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_draftProperty_price = unwrap_fragment_draftProperty_price;
exports.wrap_fragment_draftProperty_price = wrap_fragment_draftProperty_price;
exports.unwrap_fragment_draftProperty_propertyData = unwrap_fragment_draftProperty_propertyData;
exports.wrap_fragment_draftProperty_propertyData = wrap_fragment_draftProperty_propertyData;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
